import { EnumTipoReferencia } from "../enums/EnumTipoReferencia";
import { Links } from "./Links";
import { ReferenciaGerenciada } from "./ReferenciaGerenciada";
import { BaseObj } from "./UserdataSync";

export class Referencia extends BaseObj {
  tipo: EnumTipoReferencia;
  ref: string;
  link: string;
  links: Links[];
  conteudo: string;
  constructor(referencia?: Referencia) {
    super();
    this.conteudo = referencia?.conteudo;
    this.tipo = referencia?.tipo;
    this.ref = referencia?.ref;
    this.link = referencia?.link;
    this.links = referencia?.links;
  }

  static referenciaParceGerenciada(
    referenciasGerenciadas: ReferenciaGerenciada[]
  ): Referencia[] {
    const referencias: Referencia[] = referenciasGerenciadas.map(
      (x) =>
        new Referencia({
          tipo: x.tipo,
          ref: x.ref,
          link: x.link,
          links: [new Links({ idItem: x.idItem, idLei: x.idLei })],
          conteudo: x.conteudo,
          id: x.id,
          dataHoraModificacao: x.dataHoraModificacao,
          removido: x.removido,
        })
    );
    return referencias;
  }

  static identificarTipoReferencia(item: EnumTipoReferencia): string {
    switch (item) {
      case EnumTipoReferencia.Lei:
        return "Lei ou Artigo de Lei";
      case EnumTipoReferencia.SumulaVinculante:
        return "Súmula (STF/STJ ou Súmula Vinculante)";
      case EnumTipoReferencia.Julgado:
        return "Julgado";
      case EnumTipoReferencia.Informativo:
        return "Informativo";
      case EnumTipoReferencia.ArtigoJuridico:
        return "Artigo Jurídico";
      case EnumTipoReferencia.QuestaoProva:
        return "Questão de Prova";
      case EnumTipoReferencia.Outros:
        return "Outros";
      case EnumTipoReferencia.DicasEstudo:
        return "Dicas de estudo";
    }
  }

}

